import styled from 'styled-components';
import { Wrapper as Avatar } from '../../../../styled-components/components/Avatar/wrapper';
import { size } from '../../../../styled-components/layout/helpers';
import { ButtonReset } from '../../../../styled-components/layout/reset';

export const FoldoutButton = styled(ButtonReset)`
  position: relative;
  display: block;
  border-radius: ${size(2)};
  transition: transform 200ms ease;

  &::before {
    content: "";
    position: absolute;
    inset: 0;
    border: 1px solid var(--c-border-main);
    border-radius: inherit;
    opacity: 0;
    z-index: 1;
  }

  &:hover {
    &::before {
      opacity: 1;
    }
  }

  &:active {
    transform: scale(0.9);
  }
`;

export const FoldoutHeader = styled.div`
  display: flex;
  align-items: center;
  gap: ${size(1.5)};

  ${Avatar} {
    flex-shrink: 0;
  }
`;

export const FoldoutContent = styled.div`
  flex: 1 1 auto;
  min-width: 0;
`;

export const FoldoutName = styled.div`
  font-size: ${(props) => props.theme.font.size.small};
  font-weight: var(--font-weight-bold);
  hyphens: auto;
  word-break: break-word;
`;

export const FoldoutAccount = styled.div`
  font-size: ${(props) => props.theme.font.size.xsmall};
  color: var(--c-text-muted);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;
